/** 极简 DOM 构造工具。 */

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Record<string, unknown> | null,
  ...children: Array<Node | string | null | undefined>
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (props) {
    for (const [k, v] of Object.entries(props)) {
      if (v === undefined || v === null || v === false) continue;
      if (k === 'class') el.className = String(v);
      else if (k === 'text') el.textContent = String(v);
      else if (k.startsWith('on') && typeof v === 'function') {
        (el as unknown as Record<string, unknown>)[k] = v;
      } else {
        el.setAttribute(k, String(v));
      }
    }
  }
  for (const c of children) {
    if (c === null || c === undefined) continue;
    if (c instanceof Node) el.appendChild(c);
    else el.appendChild(document.createTextNode(String(c)));
  }
  return el;
}

export function clear(node: HTMLElement): void {
  node.replaceChildren();
}

export function input(
  value: string,
  placeholder = '',
  type = 'text',
  opts: { password?: boolean; multiline?: boolean } = {},
): HTMLInputElement | HTMLTextAreaElement {
  if (opts.multiline) {
    const t = document.createElement('textarea');
    t.value = value;
    t.placeholder = placeholder;
    return t;
  }
  const i = document.createElement('input');
  i.value = value;
  i.placeholder = placeholder;
  i.type = opts.password ? 'password' : type;
  return i;
}

/* ------------------------------ toast ------------------------------ */

type ToastType = 'ok' | 'err' | 'info';

const TOAST_STYLE: Record<ToastType, { bg: string; dot: string; icon: string }> = {
  ok: { bg: 'linear-gradient(180deg,#166534,#14532d)', dot: '#34d399', icon: '✓' },
  err: { bg: 'linear-gradient(180deg,#7f1d1d,#671717)', dot: '#f87171', icon: '!' },
  info: { bg: 'linear-gradient(180deg,#1e3a5f,#17293f)', dot: '#60a5fa', icon: 'i' },
};

let toastBox: HTMLElement | null = null;

/** 底部 toast：语义色（ok/err/info）+ 状态点，多条自下而上堆叠，2.6s 后淡出。 */
export function toast(msg: string, type: ToastType = 'err'): void {
  if (!toastBox || !toastBox.isConnected) {
    toastBox = document.createElement('div');
    toastBox.style.cssText =
      'position:fixed;left:50%;transform:translateX(-50%);bottom:calc(24px + env(safe-area-inset-bottom));' +
      'display:flex;flex-direction:column;align-items:center;gap:8px;z-index:99;pointer-events:none;';
    document.body.appendChild(toastBox);
  }
  const s = TOAST_STYLE[type];
  const el = document.createElement('div');
  el.style.cssText =
    `background:${s.bg};color:#fff;padding:10px 18px 10px 14px;border-radius:999px;font-size:14px;` +
    'display:flex;align-items:center;gap:8px;max-width:86vw;box-shadow:0 4px 16px rgba(0,0,0,.45);' +
    'transition:opacity .25s, transform .25s;';
  const dot = document.createElement('span');
  dot.textContent = s.icon;
  dot.style.cssText =
    `flex:0 0 auto;width:18px;height:18px;border-radius:50%;background:${s.dot};color:#0b0d12;` +
    'font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center;';
  const label = document.createElement('span');
  label.textContent = msg;
  el.append(dot, label);
  toastBox.append(el);
  setTimeout(() => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(6px)';
    setTimeout(() => el.remove(), 260);
  }, 2600);
}
